import { render } from "./ExpertDrawer.vue?vue&type=template&id=d47f1884&scoped=true"
import script from "./ExpertDrawer.vue?vue&type=script&lang=js"
export * from "./ExpertDrawer.vue?vue&type=script&lang=js"

import "./ExpertDrawer.vue?vue&type=style&index=0&id=d47f1884&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47f1884"]])

export default __exports__